import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../analytics';

/**
 * Loads GA once, then reports a page view on every client-side navigation.
 * Renders nothing, and does nothing at all when no Measurement ID is set.
 */
const Analytics: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
};

export default Analytics;
